import { isProductionEnv } from "../../../lib/currentEnvironment";
import { PopupPositions } from "../../Popup";

var isValidPosition = function isValidPosition(position) {
  return PopupPositions.includes(position);
};

export var isValidPositions = function isValidPositions(positions) {
  return positions.every(function (item) {
    if (isProductionEnv) {
      return isValidPosition(item);
    }

    if (isValidPosition(item)) {
      return true;
    }

    throw new Error("Unxpected position \"" + item + "\"");
  });
};